import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref } from "vue"

const _hoisted_1 = { class: "rounded-lg border border-gray-200 bg-gray-50 px-4 py-3 space-y-2" }
const _hoisted_2 = { class: "font-medium" }
const _hoisted_3 = { class: "w-full text-normal" }
const _hoisted_4 = { class: "text-left text-gray-500" }
const _hoisted_5 = { class: "py-1 pr-4 font-medium" }
const _hoisted_6 = { class: "py-1 pr-4 font-medium" }
const _hoisted_7 = { class: "py-1 pr-4 text-right font-medium" }
const _hoisted_8 = { class: "py-1 text-right font-medium" }
const _hoisted_9 = { class: "py-1 pr-4" }
const _hoisted_10 = { class: "py-1 pr-4 text-gray-600" }
const _hoisted_11 = { class: "py-1 pr-4 text-right" }
const _hoisted_12 = { class: "py-1 text-right font-semibold whitespace-nowrap" }

import { formatQuantity } from '@/composables/inventory/inventoryTable';
import type { MedicineDiagnosisTotal } from '@/types';


export default /*@__PURE__*/_defineComponent({
  __name: 'DiagnosisTotals',
  props: {
    totals: {}
  },
  setup(__props: any) {



function rowKey(total: MedicineDiagnosisTotal): string {
    return `${total.diagnosis ?? ''}|${total.unit_id}`;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('views.health.inventory.diagnosisTotals.heading')), 1),
    _createElementVNode("table", _hoisted_3, [
      _createElementVNode("thead", null, [
        _createElementVNode("tr", _hoisted_4, [
          _createElementVNode("th", _hoisted_5, _toDisplayString(_ctx.$t('views.health.inventory.table.headings.diagnosis')), 1),
          _createElementVNode("th", _hoisted_6, _toDisplayString(_ctx.$t('views.health.inventory.diagnosisTotals.drugs')), 1),
          _createElementVNode("th", _hoisted_7, _toDisplayString(_ctx.$t('views.health.inventory.diagnosisTotals.treatments')), 1),
          _createElementVNode("th", _hoisted_8, _toDisplayString(_ctx.$t('views.health.inventory.diagnosisTotals.quantity')), 1)
        ])
      ]),
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.totals, (total) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: rowKey(total),
            class: "border-t border-gray-200"
          }, [
            _createElementVNode("td", _hoisted_9, _toDisplayString(total.diagnosis ?? '–'), 1),
            _createElementVNode("td", _hoisted_10, _toDisplayString(total.drug_names.join(', ')), 1),
            _createElementVNode("td", _hoisted_11, _toDisplayString(_ctx.$n(total.treatments, 'numeric')), 1),
            _createElementVNode("td", _hoisted_12, _toDisplayString(_unref(formatQuantity)(total.quantity)) + " " + _toDisplayString(total.unit_name), 1)
          ]))
        }), 128))
      ])
    ])
  ]))
}
}

})